import $axios from "@/helpers/axios-helper";
import { service_names } from "@/constants/Services";
import { store } from "@/store";
import { getId } from "@/helpers/utils";
import { service_paths } from "../../constants/Services";

const state = () => ({
  socketEvent: null,
  timeSwitchedSupportChat: null,
  isLoggedInIframe: null,
  isModeSupporter: null,
  currentUsernameLoggedIn: null,
  timeExpired: null,
  totalUnreadMessage: 0
});
const getters = {
  socketEvent: state => state.socketEvent,
  timeSwitchedSupportChat: state => state.timeSwitchedSupportChat,
  isLoggedInIframe: state => state.isLoggedInIframe,
  isModeSupporterLocal: state => state.isModeSupporter,
  getTimeExpired: state => state.timeExpired,
  totalUnreadMessage: state => state.totalUnreadMessage
};
const mutations = {
  setSocketEvent(state, event) {
    state.socketEvent = event;
  },
  switchModeSupporter(state, mode) {
    state.isModeSupporter = mode;
  },
  setTimeSwitchedModeSupporter(state, time) {
    state.timeSwitchedSupportChat = time;
  },
  setStatusLoginIframe(state, status) {
    state.isLoggedInIframe = status;
  },
  setTimeExpired(state, timeExpired) {
    state.timeExpired = timeExpired;
  },
  clearInfoChat(state) {
    state.socketEvent = null;
    state.timeSwitchedSupportChat = null;
    state.isLoggedInIframe = null;
    state.isModeSupporter = null;
    state.currentUsernameLoggedIn = null;
    state.totalUnreadMessage = 0;
  },
  setTotalUnreadMessage(state, totalUnreadMessage) {
    state.totalUnreadMessage = totalUnreadMessage;
  }
};
const actions = {
  clearInfoChat(context) {
    context.commit("clearInfoChat");
  },
  verifyOnlineStatus() {
    const path = `${service_names.user}/im-still-here`;
    setInterval(async () => {
      await $axios.post(
        path,
        undefined,
        undefined,
        undefined,
        undefined,
        undefined,
        false
      );
      //  after every 30s, online status notification
    }, 30000);
  },
  async getTotalUnreadMessage({ commit, getters }) {
    const userId = getId(store.getters["user/info"]);
    // const path = `${service_paths.chat}/${
    //   getters.isModeSupporterLocal ? "supporter" : "user"
    // }/${userId}/number-message-unread`;
    const path = `${service_paths.chat}/user/${userId}/number-message-unread`;
    let { data: totalMessage } = await $axios.get(
      path,
      undefined,
      undefined,
      undefined,
      undefined,
      undefined,
      false
    );
    commit("setTotalUnreadMessage", totalMessage);
  }
};
export default { namespaced: true, state, getters, mutations, actions };
